var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlockpix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 319.812,
    height: 66.523,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x2: 1,
    y1: 0.5,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0057c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0097fb"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 75"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 81"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 80"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 79"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M560.654 4382.183a2.5 2.5 0 0 1-1.181 1.538l-25.926 14.827-.107 33.163-5-2.93v-33.033l28.518-16.4a2.5 2.5 0 0 1 1.256-.34 2.53 2.53 0 0 1 2.178 1.253 2.5 2.5 0 0 1 .262 1.922",
    "data-name": "Path 154",
    transform: "translate(-528.443 -4379.011)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00d3be",
    d: "M32.211 3.172A2.5 2.5 0 0 1 31.03 4.71L5.104 19.537 4.997 52.7l-5-2.93V16.737L28.515.337a2.5 2.5 0 0 1 1.256-.34 2.53 2.53 0 0 1 2.178 1.253 2.5 2.5 0 0 1 .262 1.922",
    "data-name": "Path 155"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 78"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 75"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00d3be",
    d: "m19.034 28.113 9.922-5.869 8.987 5.259-9.841 5.815Z",
    "data-name": "Path 156"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 76"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00ebd3",
    d: "m28.102 44.664 9.841-5.531v-11.63l-9.841 5.815Z",
    "data-name": "Path 157"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 77"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00b8a5",
    d: "M19.034 28.113v11.386l9.068 5.164V33.318Z",
    "data-name": "Path 158"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M626.567 4408.68v32.952l-28.444 16.753-10.681-6.367v-5.66l10.736 6.289 23.424-13.552v-27.664l-19.355-11.254 4.852-2.757Z",
    "data-name": "Path 159",
    transform: "translate(-569.632 -4391.862)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00d3be",
    d: "M56.935 16.818V49.77L28.491 66.523 17.81 60.156v-5.66l10.736 6.289L51.97 47.233V19.569L32.615 8.315l4.852-2.757Z",
    "data-name": "Path 160"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "m578.184 4415.753-19.3 11.173v40.908a2.355 2.355 0 0 0 4.709.013l.062-15.48 14.584 8.25 19.365-11.257v-22.511Zm14.448 30.936-14.39 8.347-14.717-8.509v-16.692l14.659-8.337 14.448 8.341Z",
    "data-name": "Path 161",
    transform: "translate(-549.692 -4404.661)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00d3be",
    d: "m28.492 11.092-19.3 11.173v40.908a2.355 2.355 0 0 0 4.709.013l.062-15.48 14.584 8.25 19.365-11.257V22.188ZM42.94 42.028l-14.39 8.347-14.717-8.509V25.174l14.659-8.337 14.448 8.341Z",
    "data-name": "Path 162"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 82"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0c1d2b",
    d: "m75.894 29.225 6.938-1.873v2.9h12.81a2.96 2.96 0 0 0 2.973-1.652 2.9 2.9 0 0 0 .22-1.064 2.38 2.38 0 0 0-1.579-2.313 4.3 4.3 0 0 0-1.615-.293H75.894l1.872-6.2h17.95q5.653 0 8.59 3.487a7.45 7.45 0 0 1 1.872 4.956 6.73 6.73 0 0 1-2.9 5.506 4.6 4.6 0 0 1-.7.514 7.74 7.74 0 0 1 4.258 5.469 6 6 0 0 1 .11 1.1 7.17 7.17 0 0 1-2.936 5.873 11.74 11.74 0 0 1-7.525 2.276H75.894Zm6.938 7.194v5.286h13.581a2.96 2.96 0 0 0 2.973-1.651 2.9 2.9 0 0 0 .22-1.065 2.36 2.36 0 0 0-1.578-2.276 4.3 4.3 0 0 0-1.615-.293Z",
    "data-name": "Path 163"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0c1d2b",
    d: "M110.582 18.726h6.938v22.979h20.514l-1.872 6.2h-25.58Z",
    "data-name": "Path 164"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0c1d2b",
    d: "M173.534 33.336q0 8.588-6.644 12.554a21.06 21.06 0 0 1-10.939 2.643q-7.966 0-12.627-4.259-4.442-4.074-4.442-10.938 0-8.112 6.02-12.224a19.37 19.37 0 0 1 11.049-3.01q8.663 0 13.4 4.515 4.184 4.002 4.183 10.719m-27.31 0q0 6.276 4.588 8.039a15.3 15.3 0 0 0 5.506.844q7.819 0 9.434-5.359a13 13 0 0 0 .44-3.523q0-7.158-6.167-8.553a17.2 17.2 0 0 0-3.708-.367q-7.085 0-9.14 4.038a11.05 11.05 0 0 0-.953 4.881",
    "data-name": "Path 165"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0c1d2b",
    d: "M187.153 18.726h18.721l-1.872 6.2h-16q-3.158 0-4.809 3.524a12.2 12.2 0 0 0-1.028 5.065q0 4.332 2.2 6.644a4.9 4.9 0 0 0 3.634 1.542h17.876l-1.872 6.2h-16.849a10.88 10.88 0 0 1-9.434-4.992 16.73 16.73 0 0 1-2.9-9.837 15.7 15.7 0 0 1 3.193-10.058 11.21 11.21 0 0 1 9.14-4.288",
    "data-name": "Path 166"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0c1d2b",
    d: "M227.75 18.726h9.581l-15.784 14.242 16.518 14.94H227.75l-11.893-11.123v11.123h-6.938V19.864l6.938-1.872v11.93Z",
    "data-name": "Path 167"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00d3be",
    d: "m241.002 29.225 6.938-1.873v5.14h13.582a2.89 2.89 0 0 0 2.863-2.056 4.8 4.8 0 0 0 .33-1.762 3.68 3.68 0 0 0-1.5-3.267 3.15 3.15 0 0 0-1.688-.477h-20.519l1.872-6.2h18.354a10.38 10.38 0 0 1 8.7 3.964 10.14 10.14 0 0 1 2.129 6.314 9 9 0 0 1-3.047 7.048 11.28 11.28 0 0 1-7.782 2.643h-13.297v9.213H241Z",
    "data-name": "Path 168"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00d3be",
    d: "M275.103 18.726h6.938v29.182h-6.937Z",
    "data-name": "Path 169"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00d3be",
    d: "m302.156 29.628 9.213-10.9h8.076l-12.26 14.426 12.627 14.756h-8.075l-9.581-11.306-9.581 11.306H284.5l12.627-14.756-12.26-14.426h8.075Z",
    "data-name": "Path 170"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockpix);
export default __webpack_public_path__ + "static/media/blockpix.880f0bfa468e2645fdf833955dbe0b20.svg";
export { ForwardRef as ReactComponent };